(function () {
  if (window.__scCartPageFixInit) return;
  window.__scCartPageFixInit = true;

  var CART_FORM = '.t4s-main-cart form[data-cart-content]';
  var QTY_SELECTOR = CART_FORM + ' .t4s-quantity-cart-item [data-quantity-selector]';
  var QTY_INPUT = CART_FORM + ' .t4s-quantity-cart-item [data-action-change][data-id]';
  var pending = null;

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function clampQty(input, qty) {
    var min = toNumber(input.getAttribute('min'), 0);
    var max = toNumber(input.getAttribute('max'), 9999);
    var step = toNumber(input.getAttribute('step'), 1) || 1;

    qty = toNumber(qty, min || 0);

    if (qty < min) qty = min;
    if (max && qty > max) qty = max;

    // Keep step-based quantities safe for products with quantity rules.
    if (step > 1 && qty > min) {
      qty = min + Math.round((qty - min) / step) * step;
    }

    return qty;
  }

  function unlockCartPage() {
    document
      .querySelectorAll(
        '.t4s-cartPage__form.is--contentUpdate, ' +
        '.t4s-main-cart form.is--contentUpdate, ' +
        '[data-cart-wrapper].is--contentUpdate, ' +
        'form[data-cart-content].is--contentUpdate, ' +
        '.is--contentUpdate'
      )
      .forEach(function (el) {
        el.classList.remove('is--contentUpdate');
      });

    document
      .querySelectorAll('.t4s-cart-ld__bar, .t4s-loading--bg, .t4s-loading-overlay')
      .forEach(function (el) {
        el.classList.add('t4s-dn');
        el.setAttribute('hidden', 'hidden');
        el.style.display = 'none';
        el.style.pointerEvents = 'none';
      });

    document.body.classList.remove('is--contentUpdate', 't4s-lock-scroll');
    document.documentElement.classList.remove('is--contentUpdate', 't4s-lock-scroll');
  }

  function setLoading(input, loading) {
    var item = input && input.closest('[data-cart-item]');
    var form =
      (input && input.closest('form[data-cart-content]')) ||
      (input && input.closest('[data-cart-wrapper]')) ||
      document.querySelector(CART_FORM);

    if (item) item.classList.toggle('is--update', !!loading);

    if (form) {
      form.classList.toggle('is--contentUpdate', !!loading);
      form.classList.toggle('is--updating-cart', !!loading);
    }

    if (!loading) {
      unlockCartPage();
    }
  }

  function getSectionIds() {
    var ids = [];

    if (window.cartT4SectionID) ids.push(window.cartT4SectionID);

    document.querySelectorAll('.t4s-main-cart, [data-cart-wrapper], [data-cart-items]').forEach(function (el) {
      var section = el.closest('[id^="shopify-section-"]');

      if (section && section.id) {
        var id = section.id.replace('shopify-section-', '');

        if (ids.indexOf(id) === -1) {
          ids.push(id);
        }
      }
    });

    return ids;
  }

  function replaceSection(id, html) {
    var current = document.getElementById('shopify-section-' + id);
    if (!current || !html) return;

    var temp = document.createElement('div');
    temp.innerHTML = html;

    var next = temp.querySelector('#shopify-section-' + id);
    if (!next) return;

    /*
      Do not replace the full cart section.

      Full section replacement can remove custom fulfillment popup/button markup.
      We only refresh the cart pieces that need to change after quantity updates.
    */

    var selectorsToRefresh = [
      '[data-cart-items]',
      '[data-cart-prices]',
      '[data-cart-discounts]',
      '[data-cart-calc-shipping]',
      '[data-cart-ship-text]',
      '[data-cart-ship-bar]',
      '[data-cart-total]',
      '[data-cart-subtotal]',
      '.t4s-cart__totalPrice',
      '.t4s-cart-total',
      '.t4s-cartPage__footer [data-cart-prices]',
      '[data-sc-cart-shipping-bar]'
    ];

    selectorsToRefresh.forEach(function (selector) {
      var currentEl = current.querySelector(selector);
      var nextEl = next.querySelector(selector);

      if (currentEl && nextEl) {
        currentEl.innerHTML = nextEl.innerHTML;

        Array.prototype.slice.call(nextEl.attributes).forEach(function (attr) {
          currentEl.setAttribute(attr.name, attr.value);
        });
      }
    });
  }

  function refreshSections(cartResponse) {
    if (cartResponse && cartResponse.sections) {
      Object.keys(cartResponse.sections).forEach(function (id) {
        replaceSection(id, cartResponse.sections[id]);
      });

      return Promise.resolve(cartResponse);
    }

    var ids = getSectionIds();

    if (!ids.length) {
      return Promise.resolve(cartResponse);
    }

    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        ids.forEach(function (id) {
          if (sections && sections[id]) {
            replaceSection(id, sections[id]);
          }
        });

        return cartResponse;
      });
  }

  function dispatchCartEvents(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('t4s:cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('t4s:cart:refresh', { detail: cart }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {}
  }

  function updateCart(input, qty) {
    var key = input.getAttribute('data-id');

    if (!key) return;

    qty = clampQty(input, qty);

    input.value = qty;
    input.setAttribute('data-current-qty', qty);

    clearTimeout(pending);
    setLoading(input, true);

    pending = setTimeout(function () {
      var ids = getSectionIds();

      var body = {
        id: key,
        quantity: qty,
        sections: ids,
        sections_url: window.location.pathname
      };

      var changeUrl =
        window.T4Sroutes && window.T4Sroutes.cart_change_url
          ? window.T4Sroutes.cart_change_url
          : '/cart/change';

      fetch(changeUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          if (cart && cart.status) {
            throw new Error(cart.description || 'Cart update failed');
          }

          return refreshSections(cart).then(function () {
            return cart;
          });
        })
        .then(function (cart) {
          dispatchCartEvents(cart);
        })
        .catch(function (err) {
          console.error('[SC cart page] quantity update failed:', err);

          if (window.T4SThemeSP && window.T4SThemeSP.Notices) {
            window.T4SThemeSP.Notices(err.message || 'Cart update failed');
          }
        })
        .finally(function () {
          setLoading(input, false);

          /*
            Extra unlock passes because Kalles/cart section refreshes can re-add
            loading classes shortly after our custom update finishes.
          */
          unlockCartPage();
          setTimeout(unlockCartPage, 100);
          setTimeout(unlockCartPage, 300);
          setTimeout(unlockCartPage, 700);
        });
    }, 120);
  }

  // Capture phase stops Kalles default cart handler from using visual row index.
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest(QTY_SELECTOR);

      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var wrapper = btn.closest('[data-quantity-wrapper]');
      var input = wrapper && wrapper.querySelector('[data-action-change][data-id]');

      if (!input) return;

      var current = toNumber(input.value, 0);
      var step = toNumber(input.getAttribute('step'), 1) || 1;
      var next = current;

      if (btn.matches('[data-increase-qty], .is--plus')) {
        next = current + step;
      }

      if (btn.matches('[data-decrease-qty], .is--minus')) {
        next = current - step;
      }

      updateCart(input, next);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target.closest(QTY_INPUT);

      if (!input) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      updateCart(input, input.value);
    },
    true
  );

  /*
    Safety: if Kalles or another cart script leaves the page locked,
    unlock it when user tries to interact.
  */
  document.addEventListener(
    'click',
    function () {
      setTimeout(unlockCartPage, 0);
    },
    false
  );

  document.addEventListener('DOMContentLoaded', function () {
    unlockCartPage();
    setTimeout(unlockCartPage, 500);
  });
})();